import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';



function Protocolocero() {
  const [selectedOption, setSelectedOption] = useState('');

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleLinkButtonClick = () => {
    let link = '';
    if (selectedOption === '1') {
      link = '../Pdf/PROTOCOLOCERO.pdf';
    } else if (selectedOption === '2') {link = '../Pdf/PRONUNCIAMIENTOCEROTOLERANCIA2023.pdf';
    } else if (selectedOption === '3') {link = '../Pdf/DIRECTORIOPERSONASCONSEJERASSEGOB.pdf';
    } else if (selectedOption === '4') {link = '../Pdf/Primercontacto.pdf';

    }
    window.open(link, '_blank');
  };

  return (

      <Row>
        <Col>
          <Card>
            <Card.Body>
              <div style={{ maxWidth: '300px' }}>
            </div>              <Card.Text>Protocolo Cero</Card.Text>
              <Form.Select
                aria-label="Default select example"
                value={selectedOption}
                onChange={handleOptionChange}
              >
                <option>- - -</option>
                <option value="1">PROTOCOLO CERO</option>
                <option value="2">PRONUNCIAMIENTO CERO TOLERANCIA 2023</option>
                <option value="3">DIRECTORIO PERSONAS CONSEJERAS SEGOB</option>
                <option value="4">FORMATO DE PRIMER CONTACTO</option>
              </Form.Select>
              <Button variant="primary" onClick={handleLinkButtonClick}>Ver</Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>

  );
}

export default Protocolocero;
